import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Command = createReactComponent("Command", ["svg", defaultAttributes, [["path", {
  d: "M18 3a3 3 0 00-3 3v12a3 3 0 003 3 3 3 0 003-3 3 3 0 00-3-3H6a3 3 0 00-3 3 3 3 0 003 3 3 3 0 003-3V6a3 3 0 00-3-3 3 3 0 00-3 3 3 3 0 003 3h12a3 3 0 003-3 3 3 0 00-3-3z",
  key: "1eeb3l"
}]]]);
export default Command;